import LRUCache from 'lru-cache';

const DEFAULT_MAX_AGE_MS = 1000 * 60 * 60; // 1 hour

export const cache = new LRUCache({
  max: 100,
  maxAge: DEFAULT_MAX_AGE_MS,
});

export const resetCache = () => cache.reset();

export const purgeCacheNamespace = (namespace: string) => {
  cache.forEach((_: any, key: string) => {
    if (key.startsWith(namespace)) {
      cache.del(key);
    }
  });
};

export async function fetchWithCache<T>(
  cacheKey: string,
  setter: () => Promise<T>,
  options: {
    ttl?: number;
  } = {}
): Promise<T> {
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey) as T;
  }

  const results = await setter();
  cache.set(cacheKey, results, options.ttl || DEFAULT_MAX_AGE_MS);
  return results;
}
